export default __webpack_public_path__ + "ChatLaw78a0ce.png";